import React from 'react';
import { Table, Button, Space, Modal, message, Card } from 'antd';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../api/axios';

const Sliders: React.FC = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { data: sliders, isLoading } = useQuery({
        queryKey: ['adminSliders'],
        queryFn: async () => {
            const response = await apiClient.get('/admin/sliders');
            return response.data.data;
        }
    });

    const deleteMutation = useMutation({
        mutationFn: async (id: string) => {
            const response = await apiClient.delete(`/admin/sliders/${id}`);
            return response.data;
        },
        onSuccess: () => {
            message.success('Slider erfolgreich gelöscht');
            queryClient.invalidateQueries({ queryKey: ['adminSliders'] });
        },
        onError: () => {
            message.error('Fehler beim Löschen des Sliders');
        }
    });

    const handleDelete = (id: string) => {
        Modal.confirm({
            title: 'Slider löschen',
            content: 'Möchten Sie diesen Slider wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
            okText: 'Löschen',
            okType: 'danger',
            cancelText: 'Abbrechen',
            onOk: () => deleteMutation.mutate(id)
        });
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text: string) => <span className="font-semibold">{text}</span>
        },
        {
            title: 'Bilder Anzahl',
            dataIndex: 'itemCount',
            key: 'itemCount',
        },
        {
            title: 'Autoplay (ms)',
            dataIndex: 'autoplaySpeed',
            key: 'autoplaySpeed',
        },
        {
            title: 'Aktionen',
            key: 'actions',
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button 
                        type="primary" 
                        icon={<EditOutlined />} 
                        onClick={() => navigate(`/admin/sliders/${record.id}`)}
                    />
                    <Button 
                        danger 
                        icon={<DeleteOutlined />} 
                        onClick={() => handleDelete(record.id)}
                    />
                </Space>
            )
        }
    ];

    return (
        <Card 
            title="Slider Management" 
            extra={
                <Button 
                    type="primary" 
                    icon={<PlusOutlined />} 
                    onClick={() => navigate('/admin/sliders/new')}
                >
                    Neuen Slider erstellen
                </Button>
            }
        >
            <Table
                columns={columns}
                dataSource={sliders}
                rowKey="id"
                loading={isLoading}
                pagination={{ pageSize: 10 }}
            />
        </Card>
    );
};

export default Sliders;
